<template>
  <div class="help-container" id="language-alert-modal">
    <div id="title">
      <div class="container">
        <img src="~@/assets/logos/Mariposa.png" alt="" />
        <language-selector />
      </div>
    </div>
    <div id="message" class="postScriptum" :style="{ background: bgColor }">
      <div class="container">
        <h2 class="title">Choose language</h2>
        <div class="">
          <b-select
            :value="locale"
            @input="updateLocale($event)"
            class="cornered language-selector has-text-centered" size="is-small" > 
            <option key="es" value="es">ES</option>
            <option key="en" value="en">EN</option>
            <option key="cn" value="cn">CN</option>
            <option key="fr" value="fr">FR</option>
            <option key="ar" value="ar">عربى</option>
            <option key="pt" value="pt">PT </option>
          </b-select>
        </div>
      </div>
    </div>
    <div id="close" class="helvetica">
      <div class="container">
        <h4 class="title is-4">
          *For proper operation, disable Google Translate's automatic translation
        </h4>  
       <b-button @click="submitLocale" expanded size="is-medium is-pink">
          {{ confirmText }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import LanguageSelector from '@/components/common/settings/LanguageSelector'
export default {
  props: ['content', 'bgColor', 'confirmText', 'title'],
  components: { LanguageSelector },
  data() {
    return {
      locale: "en"
    }
  },
  methods: {
    submitLocale() {
      localStorage.setItem('locale', this.locale)
      location.reload()
    },
    updateLocale(newVal) {
      this.locale = newVal
     
    }
  }
}
</script>

<style lang="scss">
.v-dialog-modal .v-dialog-body {
  padding: 0 !important;
}

div.v-dialog div.v-dialog-content {
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px) brightness(1.5);
}

#language-alert-modal.help-container {
  height: 100%;
  display: grid;
  grid-template-rows: min-content min-content min-content;

  > div {
    justify-self: stretch;
    display: flex;
  }
  .container {
    margin: auto;
    text-align: center;
    padding: 20px;
  }

  #title {
    .title {
      color: #ce3f86;
    }
    img {
      height: 130px;
    }
    h1 {
      font-size: 5em !important;
    }

    h4 {
      margin-bottom: 0;
    }
  }
  select * {
    color: black !important;
  }
  #close {
    .title {
      color: #ce3f86;
    }

    .help-container {
      height: 100%;
      display: grid;
      grid-template-rows: 33% 33% 33%;

      > div {
        justify-self: stretch;
        display: flex;
      }
      .container {
        margin: auto;
        text-align: center;
        padding: 20px;
      }

      #message {
        background: red; /*COLOR */
      }

      #title {
        .title {
          color: var(--rosa-dark-eco);
        }
        img {
          height: 130px;
        }
        h1 {
          font-size: 5em !important;
        }

        h4 {
          margin-bottom: 0;
        }
      }

      #close {
        .title {
          color: var(--rosa-dark-eco);
        }
        button {
          background: var(--rosa-dark-eco);
          color: white;
        }
      }
    }
  }
}
</style>
